import { useState, useRef } from "react";
import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import FormInputField from "../components/FormInputField";
import makePostRequest from "../components/utils/makePostRequest";
import { renderMatches } from "react-router-dom";

const forgotPasswordPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const verificationToken = queryParams.get("token");

  const [loading, setLoading] = useState(false);
  const [sendVerificationErrorMsg, setSendVerificationErrorMsg] = useState("");
  const [sendVerificationSuccessMsg, setSendVerificationSuccessMsg] =
    useState("");
  const [updatePasswordErrorMsg, setUpdatePasswordErrorMsg] = useState("");
  const [updatePasswordSuccessMsg, setUpdatePasswordSuccessMsg] = useState("");

  const sendVerificationRef = useRef(null);
  const updatePasswordRef = useRef(null);

  const handleSendVerfication = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSendVerificationErrorMsg("");
    setSendVerificationSuccessMsg("");

    if (sendVerificationRef.current.checkValidity()) {
      const formElements = sendVerificationRef.current.elements;

      let mail = "";

      // Check and validate
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];

        if (element.name === "mail") {
          mail = element.value;
        }
      }

      // Submit
      let hasError = false;
      try {
        const data = {
          form: "forgottenpassword",
          data: {
            mail: mail,
          },
        };
        const { error } = await makePostRequest(`reset_password`, data);
        if (error) {
          throw new Error(error);
        }
      } catch (error) {
        hasError = true;
        setSendVerificationErrorMsg(error.message);
        setLoading(false);
      } finally {
        if (!hasError) {
          setSendVerificationSuccessMsg(
            "Om epostadressen finns hos oss skickar vi ett återställningsmail dit"
          );
        }
        setLoading(false);
      }
    }
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setUpdatePasswordErrorMsg("");
    setUpdatePasswordSuccessMsg("");

    if (updatePasswordRef.current.checkValidity()) {
      const formElements = updatePasswordRef.current.elements;

      let password = "";
      let rePassword = "";
      // Check and validate
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];

        if (element.name === "password") {
          password = element.value.trim();
        }
        if (element.name === "rePassword") {
          rePassword = element.value;
        }
      }

      if (password !== rePassword) {
        setUpdatePasswordErrorMsg("Lösenorden matchar inte");
        setLoading(false);
        return;
      }

      // Submit
      let hasError = false;
      try {
        const data = {
          form: "update_password",
          data: {
            new_password: password,
            re_password: rePassword,
            verification_token: verificationToken,
          },
        };
        const { error } = await makePostRequest(`reset_password`, data);
        if (error) {
          throw new Error(error);
        }
      } catch (error) {
        hasError = true;
        setUpdatePasswordErrorMsg(error.message);
        setLoading(false);
      } finally {
        if (!hasError) {
          setUpdatePasswordSuccessMsg("Lösenordet uppdaterat");
        }
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Layout
        title="Återställ lösenord"
        description="Lugn, vi fixar ett nytt lösenord till dig"
      >
        {verificationToken ? (
          // Update Password Section
          <MainContainer>
            <ContentContainer>
              <SmallTitleText text="Välj nytt lösenord" />
              <p className="my-4">Välj ett nytt säkert och unikt lösenord</p>
              <div className="bg-neutral rounded-xl p-2 mt-2">
                <form
                  ref={updatePasswordRef}
                  onSubmit={handlePasswordUpdate}
                  className="my-4"
                >
                  <FormInputField
                    type="password"
                    name="password"
                    label="Önskat lösenord"
                    required={true}
                  />
                  <FormInputField
                    type="password"
                    name="rePassword"
                    label="Lösenord igen"
                    required={true}
                  />
                  <button
                    disabled={loading}
                    className="btn btn-primary"
                    type="submit"
                  >
                    Byt lösenord
                  </button>
                </form>
                {updatePasswordErrorMsg && (
                  <p className="font-semibold text-error">
                    {updatePasswordErrorMsg}
                  </p>
                )}
                {updatePasswordSuccessMsg && (
                  <p className="font-semibold text-success">
                    {updatePasswordSuccessMsg}
                  </p>
                )}
              </div>
            </ContentContainer>
          </MainContainer>
        ) : (
          // Forgot Password Send Mail Section
          <MainContainer>
            <ContentContainer>
              <SmallTitleText text="Glömt lösenordet" />
              <p className="my-4">Dags ett nytt lösenord</p>
              <div className="bg-neutral rounded-xl p-2 mt-2">
                <form
                  ref={sendVerificationRef}
                  onSubmit={handleSendVerfication}
                  className="my-4"
                >
                  <FormInputField
                    type="email"
                    name="mail"
                    label="Din epostadress"
                    required={true}
                  />
                  <button
                    disabled={loading}
                    className="btn btn-primary"
                    type="submit"
                  >
                    Skicka
                  </button>
                </form>
                {sendVerificationErrorMsg && (
                  <p className="font-semibold text-error">
                    {sendVerificationErrorMsg}
                  </p>
                )}
                {sendVerificationSuccessMsg && (
                  <p className="font-semibold text-success">
                    {sendVerificationSuccessMsg}
                  </p>
                )}
              </div>
            </ContentContainer>
          </MainContainer>
        )}
      </Layout>
    </>
  );
};

export default forgotPasswordPage;
